import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import IdfNewPlanSignup from "app/Components/Block/IdfNewPlanSignupBlock/IdfNewPlanSignup";
import IdfNewPlanSignupBlockData from "app/Models/Content/IdfNewPlanSignupBlockData";

export default class IdfNewPlanSignupBlock extends EpiComponent<IdfNewPlanSignupBlockData> {

    constructor(props) {
        super(props);
    }

    public render(): ReactNode | ReactNodeArray | null {
        return <IdfNewPlanSignup context={this.getContext()} iContent={this.props.data}/>
    }
}